type Props = { value: number; onChange: (v: number) => void; min?: number; label: string };

export default function QtyStepper({ value, onChange, min = 1, label }: Props) {
  return (
    <div className="inline-flex items-center border border-black/15 text-[13px]" role="group" aria-label={label}>
      <button type="button" aria-label="Decrease quantity" disabled={value <= min} onClick={() => onChange(value - 1)} className="w-8 h-8 flex items-center justify-center cursor-pointer whitespace-nowrap disabled:opacity-30 disabled:cursor-not-allowed hover:bg-black/5">
        <i className="ri-subtract-line"></i>
      </button>
      <span className="w-8 text-center tabular-nums" aria-live="polite">{value}</span>
      <button type="button" aria-label="Increase quantity" disabled={value >= 20} onClick={() => onChange(value + 1)} className="w-8 h-8 flex items-center justify-center cursor-pointer whitespace-nowrap disabled:opacity-30 hover:bg-black/5">
        <i className="ri-add-line"></i>
      </button>
    </div>
  );
}